import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppraisalReviewServiceURL, TaskmgmtServiceURL } from "../../../config/config";
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridPaginationModel,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  getGridStringOperators,
  GridSortModel,
  useGridApiRef,
  GridApiPro,
  GridHeaderFilterCellProps,
  GridRowClassNameParams,
} from "@mui/x-data-grid-pro";
import { DataGrid } from "../../util/DataGrid";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { GridFilterModel } from "@mui/x-data-grid";
import { ServiceName } from "../../../constants";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { ApplicationUser, Appraisal } from "../../../all_Interfaces";
import dayjs from "dayjs";
import { Select, OutlinedInput, ListSubheader, TextField, InputAdornment, MenuItem, ListItemText } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useResizeDetector } from "react-resize-detector";

const ITEM_HEIGHT = 24;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 8 + ITEM_PADDING_TOP,
      width: 250,
    },
    autoFocus: false,
  },
};

export const GlobalAppraisalDashboardList = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("Saved Appraisals");

  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const globalAppraisalViewName = React.useRef("Saved Appraisals");
  const [globalAppraisalFilter, setGlobalAppraisalFilter] = useState<any>({});
  const [globalAppraisal, setGlobalAppraisal] = useState<any[]>([]);
  const [userFunds, setUserFunds] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  const [searchText, setSearchText] = useState("");
  const [selectedOptions, setSelectedOptions] = useState<any>({});

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const sortColumn = React.useRef("");
  const sortColumnType = React.useRef("");

  const apiRef = useGridApiRef();

  const formatNumber = (params:any) => {
    if(params.value !== null)
      return<div style={{textAlign:'right',width:'100%'}}>
        {params.value.toLocaleString('en-US')}
      </div>
     ;
  }

    const { width,ref } = useResizeDetector();
    const [columnWidths,setColumnWidths] = useState<any>({});
  
    useEffect(()=>{
      if(width){
        const newColumnWidths = {
          column1:width * 0,
          column2:width * 0.1
        };
        setColumnWidths(newColumnWidths);
      }
    },[width])
  
  const getFormatedDate = (date: any) => {
    return date.value !== '' && date.value !== null ? dayjs(date.value, "MM-DD-YYYY hh:mm:ss").format("MMM-DD-YYYY") : '';
  } 
  const handleFilterChange = (e: any, field: string) => {}
  const customHeaderFilter = (params: GridHeaderFilterCellProps) => {
    const columnFilterList = globalAppraisalFilter[params.item.field]?.sort() || [];

    // console.log("inside filter option function: ");
    // console.log(params.item,">>>",usAppraisalFilter[params.item.field] )
    var copyColumnFilterList = [...columnFilterList];
    if (params.item.field === 'valueDate' || params.item.field === 'postedAppraisalDate' 
      || params.item.field === 'nextAppraisalDate' || params.item.field === 'created' || params.item.field === 'sendToAccountingDate')
      copyColumnFilterList = copyColumnFilterList?.map((value: string) => { 
    return value !== "" && value !== null ? dayjs(value,"MM-DD-YYYY hh:mm:ss").format("MMM-DD-YYYY") : ''}) ;



    const displayedOptions =  copyColumnFilterList.filter((option: any) => {
      if (!!searchText?.trim()?.length) {
        return option?.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      } else {
        return option;
      }
    })
      

    return (
      <Select
        labelId="select-dropdown-label"
        id="select-dropdown"
        value={selectedOptions[params.item.field] || ""}
        onChange={(e) => handleFilterChange(e, params.item.field)}
        input={<OutlinedInput  />} //label={params.item.field || "label"}
        MenuProps={MenuProps}
        sx={{ width: "100%" }}
        size="small"
        placeholder="All"
      >
        <ListSubheader>
          <TextField
            size="small"
            tabIndex={-1}
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {displayedOptions.map((name: any) => (
          <MenuItem
            key={name}
            value={name}
          >
            <ListItemText primary={name} key={name+Math.random()}/>
          </MenuItem>
        ))}
      </Select>

    )
  }

  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          console.log(cellValues);
          
          e.stopPropagation();
          navigate("/global/global-equity/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/global/global-equity/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />{ //cellValues.row.canEdit &&
              <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
            }
            
          </>
        );
      },
      width:columnWidths.column1 || 100
    },
    {
      field: "fundId", headerName: "Fund Id", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "fundName", headerName: "Fund Name", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    { field: "portfolioManager", headerName: "Portfolio Manager", valueFormatter: ( value:ApplicationUser ) => value?.firstName + " " + value?.lastName ,width:columnWidths.column2 || 100 } ,
    {
      field: "valueDate", headerName: "Value Date", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),renderCell:getFormatedDate,width:columnWidths.column2 || 100
    },
    {
      field: "status", headerName: "Status", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "numOfTenants", headerName: "No. of Tenants", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "netRentPassing", headerName: "Net Rent Passing", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "rentalValue", headerName: "Rental Value", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "grossValue", headerName: "Gross Value", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "capitalExpenditure", headerName: "Capital Expenditure", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "acquisitionCosts", headerName: "Acquisition Costs", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "netValue", headerName: "Net Value", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100
    },
    {
      field: "sayValue", headerName: "Say Value", filterable: false,renderCell:formatNumber, width:columnWidths.column2 || 100
    },

  ];

  const columnsAllPosted: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          console.log(cellValues);
          e.stopPropagation();
          navigate("/global/global-equity/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/global/global-equity/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
          </>
        );
      }
      ,width:columnWidths.column2 || 100
    },
    {
      field: "fundId", headerName: "Fund Id", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "fundName", headerName: "Fund Name", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "portfolioManager", headerName: "Portfolio Manager", valueFormatter: (value:ApplicationUser ) => value?.firstName + " " + value?.lastName, filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "appraiser1", headerName: "Appraiser 1", valueFormatter: ( value:ApplicationUser ) => value?.firstName + " " + value?.lastName, filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "appraiser2", headerName: "Appraiser 2", valueFormatter: ( value:ApplicationUser ) => value?.firstName + " " + value?.lastName, filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Value Date", filterable: false,width:columnWidths.column2 || 100
    },
    {
      field: "status",
      headerName: "Status",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    { field: "numOfTenants", headerName: "No. of Tenants", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100 },
    { field: "netRentPassing", headerName: "Net Rent Passing", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "rentalValue", headerName: "Rental Value", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "grossValue", headerName: "Gross Value", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "capitalExpenditure", headerName: "Capital Expenditure", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "acquisitionCosts", headerName: "Acquisition Costs", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100 },
    { field: "netValue", headerName: "Net Value", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100 },
    { field: "sayValue", headerName: "Say Value", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},

  ];

  const columnsPendingAppraisals: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          console.log(cellValues);
          e.stopPropagation();
          navigate("/global/global-equity/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/global/global-equity/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
          </>
        );
      }
      ,width:columnWidths.column2 || 100
    },
    {
      field: "fundId", headerName: "Fund Id", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "fundName", headerName: "Fund Name", filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "portfolioManager", headerName: "Portfolio Manager", valueFormatter: ( value:ApplicationUser ) => value.firstName + " " + value.lastName, filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    {
      field: "appraiser1", headerName: "Appraiser 1", valueFormatter: ( value:ApplicationUser ) => value.firstName + " " + value.lastName, filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    { field: "valueDate", headerName: "Value Date", filterable: false,renderCell:getFormatedDate,width:columnWidths.column2 || 100 },
    {
      field: "status",
      headerName: "Status",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),width:columnWidths.column2 || 100
    },
    { field: "numOfTenants", headerName: "No. of Tenants", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "netRentPassing", headerName: "Net Rent Passing", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "rentalValue", headerName: "Rental Value", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "grossValue", headerName: "Gross Value", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "capitalExpenditure", headerName: "Capital Expenditure", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "acquisitionCosts", headerName: "Acquisition Costs", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "netValue", headerName: "Net Value", filterable: false ,renderCell:formatNumber,width:columnWidths.column2 || 100},
    { field: "sayValue", headerName: "Say Value", filterable: false,renderCell:formatNumber,width:columnWidths.column2 || 100},

  ];

  // const [columns, setColumns] = useState(initialcolumns);
  // const [columnsAllPosted,setColumnsAllPosted] = useState(initialColumnsAllPosted);
  // const [columnsPendingAppraisals, setColumnsPendingAppraisals] = useState(initialColumnsPendingAppraisals);

  // const columnValues :{ [key: string]: any } = {
  //   "Saved Appraisals":setColumns,
  //   "Pending Appraisals":setColumnsPendingAppraisals,
  //   "Current Month - Posted Appraisals":setColumnsAllPosted,
  //   "All Posted Appraisals":setColumnsAllPosted
  // }
 

  // React.useEffect(() => {

  //   const updatedColumns = columns.map((col) => {
  //     let maxWidth = 0;
      
  //     const headerTextLength = col.headerName?.length;
  //     const headerWidth = headerTextLength != undefined ? headerTextLength * 10 + 20 :0;
  //     maxWidth = headerWidth;

  //     globalAppraisal.forEach((row) => {
  //       const cellValue = row[col.field]?.toString() || '';
  //       const cellLength = cellValue.length;

  //       const calculatedWidth = cellLength * 10;
  //       if (calculatedWidth > maxWidth) {
  //         maxWidth = calculatedWidth;
  //       }
  //     });
  //     return { ...col, width: maxWidth + 50 };

  //   });
  //   // setColumns(updatedColumns);
  //   columnValues[globalAppraisalViewName.current](updatedColumns);

  //   // console.log("hello world");
  // },[globalAppraisal]);

  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    setLoading(true);
    await GetGlobalAppraisals(paginationModel, filterModel).then(
      (data: any) => {
        console.log(data?.result?.globalAppraisals)
        setGlobalAppraisal(data?.result?.globalAppraisals);
        setGlobalAppraisalFilter(data?.result?.filters)
        setRowCount(data.result.rowCount);
      }
    ).catch((e) => {
      console.log(e);

    }).finally(() => { setLoading(false) });
  };


  const GetGlobalAppraisals = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    var fundArr: any[] = [];
    var userRoleURL = TaskmgmtServiceURL + "/userrolemaps/getall?$filter=(tolower(trim(email)) eq (tolower(trim('" + currentUserData?.email + "')))) and (status eq 'Active')";
    getApiCall(userRoleURL, ServiceName.TASKMANAGEMENTSERVICE).then((funds: any) => {
      fundArr = funds?.result.map((fund: any) => {
        return {
          fundId: fund.fundId,
          fundName: fund.fundName,
        };
      });
      setUserFunds(fundArr);
    });

    var globalAppraisalsArr: any[] = [];
    globalAppraisalsArr = filterModel?.items?.map((globalAppraisalsFilter: any) => {
      if (globalAppraisalsFilter?.value != undefined) {
        return {
          identity: globalAppraisalsFilter?.field,
          matchMode: "in",
          value: globalAppraisalsFilter?.value,
        };
      }
    });
    var url = AppraisalReviewServiceURL + "/globalappraisals/GetAppraisalsByRolesAndPermissions";
    var lazyLoadEventparameter = {
      filters: globalAppraisalsArr,
      first: paginationModel.pageSize * paginationModel.page,
      rows: paginationModel.pageSize,
      filterConditionalOperator: filterModel?.logicOperator,
      sortOrder: sortColumnType.current,
      sortField: sortColumn.current,
    };
    var payload = {
      fundDetails: userFunds,
      lazyLoadEventparam: lazyLoadEventparameter,
      viewName: globalAppraisalViewName.current,
      applicationUserEmail: currentUserData.email
    }
    const response = postApiCall(url, payload, "AppraisalReviewService").then((data: any) => data);
    return response;
  };



    // React.useEffect(() => {
    //   apiRef.current.autosizeColumns({includeHeaders:true,includeOutliers:true});
    // },[apiRef,globalAppraisal]);
    

  const handelPaginationModel = (paginationModel: GridPaginationModel) => {
    setPaginationModel(paginationModel);
    fetchData(paginationModel, filterModel);

  };

  const handelFilterModelChange = (filterModel: any) => {
    setFilterModel(filterModel);
    sessionStorage.setItem('sessionGlobalFilterObject', JSON.stringify(filterModel));
    fetchData(paginationModel, filterModel);

  };

  const handleDashboardViewChange = (event: React.SyntheticEvent, newValue: string) => {
    setFilterModel({ items: [] });
    sessionStorage.setItem('sessionGlobalFilterObject', JSON.stringify({ items: [] }));
    globalAppraisalViewName.current = newValue;
    sessionStorage.setItem("SessionGlobalAppraisalDashboardView", newValue);
    setValue(newValue);
    fetchData(paginationModel, { items: [] });
  };

  const handelSortModelChange = (sortModel: GridSortModel) => {

    if (sortModel.length == 0) {
      sortColumn.current = "";
      sortColumnType.current = "0";
    }
    else {
      sortColumn.current = sortModel[0].field;
      if (sortModel[0].sort == 'asc') {
        sortColumnType.current = "1";
      }
      else {
        sortColumnType.current = "0";
      }
    }
    fetchData(paginationModel, filterModel);
  };


  useEffect(() => {
    // Access initial value from session storage
    var dashboardView = sessionStorage.getItem("SessionGlobalAppraisalDashboardView");

    if (dashboardView == null) {
      //set default
      setValue("Saved Appraisals");
      sessionStorage.setItem("SessionGlobalAppraisalDashboardView", "Saved Appraisals");
      globalAppraisalViewName.current = "Saved Appraisals";
      fetchData(paginationModel, { items: [] });
    } else {
      // get filters and set filter object
      globalAppraisalViewName.current = dashboardView;
      var filtersobj = sessionStorage.getItem("sessionGlobalFilterObject")
      if (filtersobj != null) {
        var filterObject = JSON.parse(filtersobj);
        setFilterModel(filterObject);
        setValue(dashboardView);
        fetchData(paginationModel, filterObject);
      }
      else {
        fetchData(paginationModel, filterModel);
      }
    }
  }, []);


  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  };


  return (
    <Container maxWidth={false} className="dashboard-wrap">
      <Stack direction="row" spacing={2} className="user-role-action-btn">
        <div></div>
      </Stack>

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            
            <TabList
              onChange={handleDashboardViewChange}
              aria-label="Appraisals Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Saved Appraisals" value="Saved Appraisals"  sx={{textTransform:'capitalize'}}/>
              <Tab label="Pending Appraisals" value="Pending Appraisals"  sx={{textTransform:'capitalize'}}/>
              <Tab label="Current Month - Posted Appraisals" value="Current Month - Posted Appraisals"  sx={{textTransform:'capitalize'}}/>
              <Tab label="All Posted Appraisals" value="All Posted Appraisals"  sx={{textTransform:'capitalize'}}/>
            </TabList>
          </Box>


          <TabPanel ref={ref} value="Saved Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "#253746",
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "white",
                  },
                  '& .MuiDataGrid-cell' :{
                    whiteSpace:'normal',
                    wordWrap:'break-word',
                    lineHeight:'1.5rem',
                    alignItems:'center',
                    display:'flex',
                    justifyContent:'file-start',
                    marginBottom:'5px',
                    textAlign:'left',
                  },
                  '& .MuiDataGrid-columnSeparator':{
                      visibility:'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={globalAppraisal}
                rowCount={rowCount}
                columns={columns}
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                pageSizeOptions={[10, 25, 50,]}
                // rowHeight={40}
              
                getRowHeight={() => 'auto'}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>

          <TabPanel value="Pending Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "#253746",
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "white",
                  },
                  '& .MuiDataGrid-cell' :{
                    whiteSpace:'normal',
                    wordWrap:'break-word',
                    lineHeight:'1.5rem',
                    alignItems:'center',
                    display:'flex',
                    justifyContent:'file-start',
                    marginBottom:'5px',
                    textAlign:'left',
                  },
                  '& .MuiDataGrid-columnSeparator':{
                      visibility:'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={globalAppraisal}
                rowCount={rowCount}
                columns={columnsPendingAppraisals}
                paginationModel={paginationModel}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50,]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="Current Month - Posted Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "#253746",
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "white",
                  },
                  '& .MuiDataGrid-cell' :{
                    whiteSpace:'normal',
                    wordWrap:'break-word',
                    lineHeight:'1.5rem',
                    alignItems:'center',
                    display:'flex',
                    justifyContent:'file-start',
                    marginBottom:'5px',
                    textAlign:'left',
                  },
                  '& .MuiDataGrid-columnSeparator':{
                      visibility:'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={globalAppraisal}
                rowCount={rowCount}
                columns={columnsAllPosted}
                paginationModel={paginationModel}
                onPaginationModelChange={handelPaginationModel}
                paginationMode="server"
                filterMode="server"
                filterModel={filterModel}
                loading={loading}
                pageSizeOptions={[10, 25, 50,]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
                />
            }
          </TabPanel>
          <TabPanel sx={{width:'100%'}} value="All Posted Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-headerFilterRow":{
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell' :{
                    whiteSpace:'normal',
                    wordWrap:'break-word',
                    lineHeight:'1.5rem',
                    alignItems:'center',
                    display:'flex',
                    justifyContent:'file-start',
                    marginBottom:'5px',
                    textAlign:'left',
                  },
                  '& .MuiDataGrid-columnSeparator':{
                      visibility:'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={globalAppraisal}
                rowCount={rowCount}
                columns={columnsAllPosted}
                paginationModel={paginationModel}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                paginationMode="server"
                pageSizeOptions={[10, 25, 50,]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                filterMode="server"
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
};


